import React from 'react';

import Traffic from '../../asset/mission2-icon-traffic.png';
import Person from '../../asset/mission2-icon-person.png';
import Safe from '../../asset/mission2-icon-safe.png';
import Parking from '../../asset/mission2-icon-parking.png';
import Price from '../../asset/mission2-icon-price.png';
import Walk from '../../asset/mission2-icon-walk.png';
import Quiet from '../../asset/mission2-icon-quiet.png';
import Young from '../../asset/mission2-icon-young.png';
import Tasty from '../../asset/mission2-icon-tasty.png';
import Road from '../../asset/mission2-icon-road.png';
import Build from '../../asset/mission2-icon-build.png';
import Convenience from '../../asset/mission2-icon-convenience.png';

import { 
  Wrap,
  GridWrap,
  Button, 
  Text,
  Icon
} from './style';

const SurveyData = [
  { name: '교통이 편해요', icon: Traffic },
  { name: '유동인구가 많아요', icon: Person },
  { name: '안전한 느낌이 들어요', icon: Safe },
  { name: '주차하기 편해요', icon: Parking },
  { name: '시세가 적당해요', icon: Price },
  { name: '산책할 수 있어요', icon: Walk },
  { name: '조용해서 쉬기 좋아요', icon: Quiet },
  { name: '젊은 사람이 많아요', icon: Young },
  { name: '맛집이 많아요', icon: Tasty },
  { name: '오르막길이 없어요', icon: Road },
  { name: '신축이 많아서 깨끗해요' , icon: Build },
  { name: '필요한 시설이 가까워요', icon: Convenience },
];

const Mission2Quiz = ({
  selectedResult,
  onClickItem,
}) => {
  return (
    <Wrap>
      <GridWrap>
        {SurveyData?.map((value, index) => (
          <Button
            key={index}
            checked={selectedResult.includes(value.name)}
            onClick={onClickItem.bind(null, value.name)}
          >
            <Icon src={value.icon} />
            {value.name}
          </Button>
        ))}
      </GridWrap>
      
      <Text>최소 3가지 이상 선택해주세요</Text>
    </Wrap>
  );
};

export default Mission2Quiz;
